<template>
  <div class="options-input">
    <label v-if="label" v-bind="labelBindings">{{ label }}</label>
    <div class="options d-flex mb-2" :class="layoutClass">
      <button
          v-for="option in options"
          :key="option.value"
          type="button"
          :value="option.value"
          class="btn btn-outline-info"
          :class="{ active: selected(option.value) }"
          @click="onClick">
        {{ option.label || option.value }}
      </button>
    </div>
    <p v-if="invalid" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>
<script>
import BaseInput from './BaseInput'

export default {
  extends: BaseInput,

  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    value: {
      default () {
        return this.$props.multiple ? [] : null
      }
    },
    layout: {
      type: String,
      default: 'auto'
    }
  },

  methods: {
    onClick (event) {
      let value = event.target.value

      if (! this.multiple) {
        this.$emit('input', value)
      } else {
        let selection = [...this.value]
        if (selection.includes(value)) {
          selection = selection.filter(s => s !== value)
        } else {
          selection.push(value)
        }
        this.$emit('input', selection)
      }
    },

    selected (value) {
      return this.multiple ? this.value.includes(value) : (this.value === value)
    }
  },

  computed: {
    layoutClass () {
      return 'options-' + this.layout
    }
  }
}
</script>
